module.exports = __webpack_public_path__ + "static/media/learning_curve_regular_ot_tt.6409494a.ttf";